import React from 'react';
import { StandingsSidebar } from '../../components/shared';

interface Player {
  id: string;
  name: string;
  score: number;
  avatar?: string;
}

interface NewPackHostShellProps {
  /** Header / top chrome (already includes room code, etc.) */
  header: React.ReactNode;
  /** Main game content — left ~2/3 */
  children: React.ReactNode;
  players: Player[];
  questionId?: string;
  shouldUpdateScores?: boolean;
  /** Extra class on outer .app */
  className?: string;
}

/**
 * Standard host layout for Toyo New games (same as Blitz/Family/Co-op hosts):
 * left 2/3 = question / game, right 1/3 = standings.
 */
export const NewPackHostShell: React.FC<NewPackHostShellProps> = ({
  header,
  children,
  players,
  questionId,
  shouldUpdateScores = false,
  className = '',
}) => {
  return (
    <div className={`app ${className}`.trim()}>
      {header}
      <div className="game-host-layout">
        <div className="game-host-left no-image host-only">
          <div
            className="game-host-question-section"
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              minHeight: 0,
              justifyContent: 'flex-start',
              alignItems: 'stretch',
              overflowY: 'auto',
            }}
          >
            {children}
          </div>
        </div>
        <div className="game-host-right">
          <StandingsSidebar
            players={players}
            liveAnswers={[]}
            totalPlayers={players.length}
            questionId={questionId}
            shouldUpdateScores={shouldUpdateScores}
          />
        </div>
      </div>
    </div>
  );
};
